<!--
	Obrazovka so súhrnnými informáciami
-->
<script lang="ts">
	import { DialerAgentStatus } from "../libs/app/dialer-agent-enums";
	import { api, dialerAgent, scheduledCalls } from "../bootstrap";
	import { writable, Writable } from "svelte/store";
	import { onDestroy } from "svelte";
	import type { ScheduledCall } from "../libs/app/scheduled-call";

	const microphonePermissionStatus: Writable<string> = writable(); // prompt, granted, denied

	const unsubsribeMicrophonePermissionStatus =
		microphonePermissionStatus.subscribe((status) => {
			if (status === "prompt") {
				navigator.mediaDevices.getUserMedia({ audio: true });
			}
		});

	dialerAgent.target = null;
	dialerAgent.status.set(DialerAgentStatus.Idle);

	api.getScheduledCalls().then((result: Array<ScheduledCall>) => {
		scheduledCalls.set(result);
	});

	navigator.permissions
		.query({ name: "microphone" })
		.then((permissionStatus) => {
			microphonePermissionStatus.set(permissionStatus.state);

			permissionStatus.onchange = function () {
				microphonePermissionStatus.set(this.state);
			};
		})
		.catch((error) => {
			const message = error.toString();
			if (
				message ===
				"TypeError: 'microphone' (value of 'name' member of PermissionDescriptor) is not a valid value for enumeration PermissionName."
			) {
				fallbackGetMicrophonePermissionStatus();
			} else {
				console.error(message);
			}
		});

	// https://stackoverflow.com/a/53155894
	async function fallbackGetMicrophonePermissionStatus() {
		microphonePermissionStatus.set("prompt");

		// Then somewhere
		await navigator.mediaDevices
			.getUserMedia({ audio: true })
			.then((e) => {
				microphonePermissionStatus.set("granted");
			})
			.catch((err) => {
				if (err.name === "NotAllowedError") {
					microphonePermissionStatus.set("denied");
				}
			});
	}

	onDestroy(() => {
		unsubsribeMicrophonePermissionStatus();
	});
</script>

<svelte:head>
	<title>Prehľad | DialerAgent</title>
</svelte:head>

{#if $microphonePermissionStatus == "denied"}
	<div class="container mt-3">
		<div class="alert alert-danger" role="alert">
			<p class="card-text">
				Nemáte povolené použitie mikrofónu, povoľte ho prosím v
				nastaveniach prehliadača
			</p>
		</div>
	</div>
{/if}
